module.exports = __webpack_public_path__ + "static/media/IMG-2.f060bf6c.jpg";